<template>
    <div class="Monitorar">
        <button @click="reportar" type="button" class="btn -clear -hasIcon">
            <icon name="bell" size="large" class="-left"></icon>
            <span class="label">Monitorar processo</span>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
          type: {
            default: 'processo',
          }
        },
    }
</script>

<style lang="stylus">
</style>
